import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoadingComponent {

  data : any;

  constructor(
    public matDialogRef: MatDialogRef<LoadingComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any) { 
      this.data = _data;

      this.establecerContenido();
    }

  private establecerContenido(){

    let tituloDefecto = "Cargando";
    let mensajeDefecto = "Señor(a) usuario(a), por favor espere un momento";

    if(this.data == null)
    {
      this.data = { titulo: tituloDefecto, mensaje: mensajeDefecto}
    }
    else
    {
      if(this.data.titulo == null || this.data.titulo == "")
      {
        this.data.titulo = tituloDefecto;
      }

      if(this.data.mensaje == null)
      {
        this.data.mensaje = mensajeDefecto;
      }
    }

  }

}
